export default theme => ({
  admin__icon: {
    color: theme.menus.icons,
    width: 30,
    height: 25,
    display: 'flex'
  }
})
